// extracted by mini-css-extract-plugin
module.exports = {"container":"bO","logo":"bP","mainPanel":"bQ"};